export function focusFindingPdf(url,row,side,sessionId){
  if(!row?.finding_key)return url||'';
  const index=side==='reference'?row.ref_file_index:row.file_index;
  if(!url&&(index===null||index===undefined||index===''))return '';
  const parsed=new URL(url||'/wiz/api/page.chatbot.room/serve_highlighted_pdf','https://viewer.local');
  if(!/\/wiz\/api\/page\.chatbot\.room\/serve_(?:highlighted_pdf|pdf|hwp_page)$/.test(parsed.pathname))return url||'';
  parsed.pathname='/wiz/api/page.chatbot.room/serve_highlighted_pdf';
  parsed.searchParams.set('session_id',sessionId);
  if(!parsed.searchParams.has('file_index')&&index!==null&&index!==undefined)parsed.searchParams.set('file_index',String(index));
  parsed.searchParams.set('finding_key',row.finding_key);
  parsed.searchParams.set('finding_side',side);
  parsed.hash='';
  return parsed.pathname+parsed.search;
}
export function copyFindingFocus(destination,source){
  if(!destination||!source)return destination;
  const input=new URL(source,'https://viewer.local'),output=new URL(destination,'https://viewer.local');
  for(const key of ['finding_key','finding_side'])if(input.searchParams.has(key))output.searchParams.set(key,input.searchParams.get(key));
  return output.pathname+output.search+output.hash;
}
